import { ContentIcon } from './shared/ContentIcon';
import { ContentType } from 'constants/types';
import React from 'react';

export const GroupCellRenderer = ({ data }) => (
  <div className={data.group ? ContentType.group : ContentType.account}>
    <ContentIcon cgroupId={data.cgroupId} isGroup={data.group} />
    <span>{data.description}</span>
  </div>
);
